import { create } from "zustand";
import axiosToken from "../api/axiosClient";
import { toast } from "react-toastify";

const userManagementStore = create((set, get) => ({
    isLoadingClients: false,
    clients: [],
    isLoadingReservation: false,
    reservation: [],

    isLoadingRole: false,
    roles: [],

    temporaryReservation: null,
    setTemporaryReservation: (idRdv) => {
        set({ temporaryReservation: idRdv })

        setTimeout(() => {
            set({ temporaryReservation: null })
        }, 10000);
    },
    // Fonction pour récupérer tous les rôles
    getAllRole: async () => {
        set({ isLoadingRole: true });

        try {
            const response = await axiosToken.get("/role");
            const dataRole = response.data || [];

            set({
                roles: dataRole,
                isLoadingRole: false,
            });

            return dataRole;
        } catch (error) {
            console.error("Erreur getAllRole :", error);
            toast.error(
                error?.response?.data?.error || "Erreur lors du chargement des rôles."
            );
            set({ isLoadingRole: false });
            return null;
        }
    },


    syncClientStatusChange: (clientId, newStatus) => {
        set(state => ({
            clients: state.clients.map((client) => {
                if (client.id === clientId) {
                    return {
                        ...client,
                        is_active: newStatus
                    };
                }
                return client;
            })
        }));
    },
    syncAddNewClient: (newClient) => {
        set(state => ({
            clients: [...state.clients, newClient]
        }));
    },

    // Récupérer la liste de tous les clients
    // Fonction pour récupérer tous les clients
    getAllClient: async () => {
        set({ isLoadingClients: true });

        try {
            const response = await axiosToken.get("/user/all/clients");
            const users = response.data?.data?.users || [];

            set({
                clients: users,
                isLoadingClients: false,
            });

            return response.data.data;
        } catch (error) {
            console.error("Erreur getAllClient :", error);
            toast.error(
                error?.response?.data?.error || "Erreur lors du chargement des clients."
            );
            set({ isLoadingClients: false });
            return null;
        }
    },


    // Récupérer la liste de toutes les réservations
    getAllReservations: async () => {
        set({ isLoadingReservation: true });

        try {
            const response = await axiosToken.get(`/reservation`);
            const reservations = response.data?.data || [];
            // console.log({ reservations })

            set({ reservations: reservations, isLoadingReservation: false });
            return reservations;
        } catch (error) {
            console.error("Erreur getAllReservations :", error);
            toast.error(error?.response?.data?.error || "Erreur lors du chargement des réservations.");
            set({ isLoadingReservation: false });
            return [];
        }
    },

    // user/lock/{userID}
}))

export default userManagementStore;
